import React from 'react';
import siteContent from '../data/siteContent';
import './About.css';

export default function About() {
  const { about } = siteContent;

  return (
    <section id="about" className="about-section">
      <div className="section-inner">
        <div className="about-grid">
          <div className="about-text">
            <div className="section-label">{about.sectionLabel}</div>
            <h2>{about.heading}</h2>
            <p className="section-sub">{about.subtext}</p>
            <ul className="expertise-list">
              {about.expertise.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="about-visual">
            <div className="about-accent-block" />
            <div className="about-box">
              {about.body.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
            <div className="about-accent-block-br" />
          </div>
        </div>
      </div>
    </section>
  );
}
